/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { type WithScheduledTransactionItemRequestBuilder, WithScheduledTransactionItemRequestBuilderRequestsMetadata } from './item';
// @ts-ignore
import { type BaseRequestBuilder, type Guid, type KeysToExcludeForNavigationMetadata, type NavigationMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /scheduledtransactions/paid
 */
export interface PaidRequestBuilder extends BaseRequestBuilder<PaidRequestBuilder> {
    /**
     * Gets an item from the MoneyChecker.Web.ApiClient.scheduledtransactions.paid.item collection
     * @param scheduledTransactionId The Guid identifier of the scheduled transaction
     * @returns {WithScheduledTransactionItemRequestBuilder}
     */
     byScheduledTransactionId(scheduledTransactionId: Guid) : WithScheduledTransactionItemRequestBuilder;
}
/**
 * Uri template for the request builder.
 */
export const PaidRequestBuilderUriTemplate = "{+baseurl}/scheduledtransactions/paid";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const PaidRequestBuilderNavigationMetadata: Record<Exclude<keyof PaidRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    byScheduledTransactionId: {
        requestsMetadata: WithScheduledTransactionItemRequestBuilderRequestsMetadata,
        pathParametersMappings: ["scheduledTransactionId"],
    },
};
/* tslint:enable */
/* eslint-enable */
